import apiClient from "../utils/apiClient";

export const getAllBlogs = async () => {
  try {
    const response = await apiClient().get(`blog/get-all-blogs/`);

    return response;
  } catch (error) {
    console.error("Error while getting all blogs data", error);
    //return error
  }
};

export const addBlog = async (name, blog_text) => {
  const data = { name, blog_text };
  try {
    const response = await apiClient().post(`blog/create-blog/`, data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    return response;
  } catch (error) {
    console.error("Error while creating blog", error);
    //return error
  }
};

export const getBlogById = async (blog_id) => {
  try {
    const response = await apiClient().get(`blog/get-blog-by-id/${blog_id}/`);
    return response;
  } catch (error) {
    console.error("Error while creating blog", error);
    //return error
  }
};

export const updateBlogById = async (blog_id, formData) => {
  try {
    const response = await apiClient().put(
      `blog/update-blog/${blog_id}/`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response;
  } catch (error) {
    console.error("Error while creating blog", error);
    //return error
  }
};

export const deleteBlogById = async (blog_id) => {
  try {
    const response = await apiClient().delete(`blog/delete-blog/${blog_id}/`);
    return response;
  } catch (error) {
    console.error("Error while creating blog", error);
    //return error
  }
};
